import gql from 'graphql-tag';

const QUERY_HOMECARDS = gql`
  query Homecards($ids: [Int], $locale: String = "en") {
    homecards(homecardIds: $ids, locale: $locale) {
      adId
      checked
      currencyIsoCode
      cancellationPolicy
      features
      firstAvailableDate
      id
      noSecurityDeposit
      isInstantBooking
      isFavorite
      isNew
      isSuperlister
      isSelect
      mainPhotoUrl
      monthlyPrice {
        fixedPrice
        minimumPrice
        pricesByMonth {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
        type
      }
      photos
      photoUrls {
        homecard
        homecardHidpi
      }
      reviews {
        ratingAverage
      }
      title
      type
      url
    }
  }
`;

const getHomecardsQuery = client => (ids, locale) =>
  client.query({
    fetchPolicy: 'network-only',
    query: QUERY_HOMECARDS,
    variables: { ids, locale }
  });

export default getHomecardsQuery;
